// screens
import SignUp from '../screens/SignUp';
import Login from '../screens/Login';
import LoginSsoEpicDisney from '../screens/LoginSsoEpicDisney';
import LoginSsoAzureMedtronic from '../screens/LoginSsoAzureMedtronic';
import Logout from '../screens/Logout';
import Book from '../screens/Book';
import CyclePayment from '../screens/CyclePayment/CyclePayment';
import MyJourney from '../screens/MyJourney';
import Dashboard from '../screens/Dashboard';
import Appointments from '../containers/Appointments';
import { ResultsScreen } from '../screens/Results';
import Documents from '../screens/Documents/Documents';
import MedicationInstructions from '../screens/MedicationInstructions/MedicationInstructions';
import MedicationInstruction from '../screens/MedicationInstructions/MedicationInstruction';
import Settings from '../screens/Settings';
import ForgotPassword from '../screens/ForgotPassword';
import VerificationCodePage from '../screens/VerificationCodePage';
import InformedConsent from '../screens/InformedConsent';
import Messages from '../screens/Messages/Messages';
import MyProfile from '../screens/MyProfile';
import BookingQuiz from '../screens/BookingQuiz';
import Invoices from '../screens/Invoices';
import InvoiceDetails from '../screens/InvoiceDetails';
import { Kindbody360Index } from 'screens/Kb360';

// Layouts
import MainLayout from '../layouts/MainLayout';
import LeftImage from '../layouts/LeftImage';
import Plain from '../layouts/Plain';
import SimpleLayout from '../layouts/SimpleLayout';
import SSOLoginLayout from 'layouts/SSOLoginLayout';

import withProtectedRoute from './withProtectedRoute';
import MobileOAuth from '../screens/MobileOAuth';
import { MESSAGING } from 'config/features';
import RedirectToDashboard from './RedirectToDashboard';
import { withFFRouter } from 'hoc/FFRouter';
import RedirectToEnterpriseMembership from './RedirectToEnterpriseMembership';
import ResourcesLibrary from 'screens/ResourcesLibrary';
import CareTeam from 'screens/CareTeam/CareTeam';

export default [
  {
    path: '/',
    component: withProtectedRoute(Dashboard),
    layout: MainLayout,
    page: {
      name: 'Dashboard'
    }
  },
  {
    path: '/create-account',
    component: SignUp,
    layout: SimpleLayout
  },
  {
    path: '/sign-up',
    component: SignUp,
    layout: LeftImage,
    skipToSignUp: true
  },
  {
    path: '/appointments',
    component: withProtectedRoute(Appointments),
    layout: MainLayout
  },
  {
    path: '/book',
    component: withProtectedRoute(Book),
    layout: MainLayout
  },
  {
    path: '/confirmation',
    component: withProtectedRoute(Book),
    layout: MainLayout
  },
  {
    path: '/cycle-payments',
    component: withProtectedRoute(CyclePayment, { landingPage: 'signup' }),
    layout: MainLayout
  },
  {
    path: '/results',
    component: withProtectedRoute(ResultsScreen),
    layout: MainLayout
  },
  // TODO Remove when all links (emails, outside of this app, etc.) have been migrated
  {
    path: '/myjourney',
    component: withProtectedRoute(MyJourney),
    layout: MainLayout
  },
  {
    path: '/my-journey',
    component: withProtectedRoute(MyJourney),
    layout: MainLayout
  },
  {
    path: '/documents',
    component: withProtectedRoute(Documents),
    layout: MainLayout
  },
  {
    path: '/settings',
    component: withProtectedRoute(Settings),
    layout: MainLayout
  },
  {
    path: '/login',
    component: Login,
    layout: LeftImage
  },
  {
    path: '/login-sso/epic-disney',
    component: LoginSsoEpicDisney,
    layout: SSOLoginLayout
  },
  {
    path: '/login-sso/azure-medtronic',
    component: LoginSsoAzureMedtronic,
    layout: SSOLoginLayout
  },
  {
    path: '/logout',
    component: Logout,
    layout: LeftImage
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    layout: LeftImage
  },
  {
    path: '/consents/:id',
    component: withProtectedRoute(InformedConsent),
    layout: MainLayout
  },
  {
    path: '/verification-code',
    component: VerificationCodePage,
    layout: LeftImage
  },
  {
    path: '/medication-instructions',
    component: MedicationInstructions,
    layout: MainLayout
  },
  {
    path: '/medication-instruction',
    component: MedicationInstruction,
    layout: MainLayout
  },
  {
    path: '/messages',
    component: withProtectedRoute(withFFRouter(RedirectToDashboard, Messages, MESSAGING)),
    layout: MainLayout
  },
  {
    path: '/mobile-oauth',
    component: MobileOAuth,
    layout: Plain
  },
  {
    path: '/my-profile',
    component: withProtectedRoute(MyProfile),
    layout: MainLayout
  },
  {
    path: '/booking-quiz',
    component: BookingQuiz,
    layout: SimpleLayout
  },
  {
    path: '/activate-kindbody-benefit',
    component: RedirectToEnterpriseMembership,
    layout: MainLayout
  },
  {
    path: '/kindbody-benefit',
    component: RedirectToEnterpriseMembership,
    layout: MainLayout
  },
  {
    path: '/invoices',
    component: withProtectedRoute(Invoices),
    layout: MainLayout
  },
  {
    path: '/invoices/:id',
    component: withProtectedRoute(InvoiceDetails),
    layout: MainLayout
  },
  {
    path: '/resources',
    component: withProtectedRoute(ResourcesLibrary),
    layout: MainLayout
  },
  {
    path: '/kindbody/360',
    component: withProtectedRoute(Kindbody360Index),
    layout: MainLayout
  },
  {
    path: '/care-team',
    component: withProtectedRoute(CareTeam),
    layout: MainLayout
  }
];
